import { ListingDetail } from '@deltek/specification-client/core/Models/listing'
import { ManufacturerProductPropertyOptionDetail } from '@deltek/specification-client/core/Models/product'
import { ProductListingDetailInput } from '@deltek/specification-client/core/Models/productListingDetail'

const mapOption = (opt: Partial<ManufacturerProductPropertyOptionDetail>) => ({
    isOther: opt.isOther,
    isPremium: opt.isPremium,
    isPremiumPlus: opt.isPremiumPlus,
    optionId: opt.optionId,
    value: opt.value,
    isUnitOfMeasure: opt.isUnitOfMeasure,
    imperialUnits: opt.imperialUnits,
    metricUnits: opt.metricUnits,
    isInlineTextOnly: opt.isInlineTextOnly,
})

export const listingDetailToSaveInput = (
    detail: Partial<ListingDetail>,
    overrides: Record<string, unknown> = {}
): Partial<ProductListingDetailInput> =>
    ({
        listingId: detail.listingId,
        firmId: detail.firmId,
        productName: detail.productName ?? '',
        productType: detail.productType ?? '',
        sectionNumber: detail.sectionNumber ?? '',
        sectionTitle: detail.sectionTitle ?? '',
        model: detail.model ?? '',
        longDescription: detail.longDescription ?? '',
        type: detail.type ?? '',
        isActive: detail.isActive ?? false,
        submissionStatus: detail.submissionStatus ?? '',
        categories: detail.categories ?? [],
        buildingTypes: detail.buildingTypes ?? [],
        firstPublished: detail.firstPublished ?? '',
        lastPublished: detail.lastPublished ?? '',
        contentLibrary: detail.contentLibrary ?? '',
        canAutoGenerateProductSpecification:
            detail.canAutoGenerateProductSpecification ?? false,
        assignedBPMUsers: (detail.assignedBPMUsers ?? []).map((u) => ({
            userId: u.userId ?? u.id,
            role: u.role,
        })),
        assignedDeltekUsers: (detail.assignedDeltekUsers ?? []).map((u) => ({
            userId: u.userId ?? u.id,
            role: u.role,
        })),
        assignedContactUsers: (detail.assignedContactUsers ?? []).map((u) => ({
            userId: u.id,
            role: u.role,
        })),
        images: (detail.images ?? []).map((each) => ({
            id: each.id,
            isPrimary: each.isPrimary,
            order: each.order,
            originalFilename: each.originalFilename,
            url: each.filename,
        })),
        documents: (detail.manufacturerDocs ?? []).map((each) => ({
            fileName: each.path,
            docType: each.docType,
            docVariation: each.docVariation,
            expirationDate: each.expirationDate,
            id: each.id,
            title: each.title,
        })),
        videos: (detail.videos ?? []).map((each) => ({
            fromSource: each.fromSource,
            id: each.id,
            order: each.order,
            videoId: each.videoId,
            videoStillImageUrl: each.videoStillImageUrl,
        })),
        webLinks: (detail.webLinks ?? []).map((each) => ({
            order: each.order,
            type: each.type,
            url: each.url,
        })),
        partnershipLinks: (detail.partnershipLinks ?? []).map((each) => ({
            level: each.level,
            name: each.name,
            partnerType: each.partnerType,
            url: each.url,
        })),
        properties: ((detail.properties ?? []).map((prop) => ({
            propertyId: prop.propertyId,
            propertyName: prop.propertyName,
            isPremiumPlus: prop.isPremiumPlus,
            subPropertyName: prop.subPropertyName,
            originalPropertyName: prop.originalPropertyName,
            options: (prop.options ?? []).map(mapOption),
            optionGroups: (prop.optionGroups ?? []).map((group) => ({
                groupId: group.groupId,
                prefix: group.prefix,
                postfix: group.postfix,
                options: (group.options ?? []).map(mapOption),
            })),
        })) as unknown) as Partial<ProductListingDetailInput>['properties'],
        ...overrides,
    } as Partial<ProductListingDetailInput>)
